module.exports = "\r\n@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:400italic,700italic,300,400,700\");\n/* You can add global styles to this file, and also import other style files */\n/* #GOOGLE FONT */\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles